<template>
  <div class="brandIdBlock">
    <el-button type="primary" v-if="!batchBrand" @click="useBrandConf" style="margin-bottom: 10px">一键应用品牌配置</el-button>
    <el-input v-if="!batchBrand" width="200px" style="margin-left: 10px;" type="text" clearable placeholder="输入品牌,回车后匹配填充" v-model="inputBrandText" @keyup.enter.native="batchFillBrand"> </el-input>
    <el-form ref="formRef" :model="valueMap" :label-width="source !='batchDelete'? '360px':'180px'">
      <el-form-item v-for="item in shopBrandList" :key="item.shopId" :prop="String(item.shopId)" :rules="itemRules(item)">
        <span slot="label">
          <el-image :src="item.shopIcon" style="height: 16px; margin-right:5px"></el-image>
          <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px 6px 0px 6px;">
              <el-image :src="item.channelIcon" style="width: 18px; height: 18px;"></el-image>
          </el-tooltip>
          <span>{{ item.shopName }}</span>
        </span>
        <el-select
          :value="valueMap[item.shopId]"
          value-key="vid"
          name-key="vvalue"
          v-loading="loading[item.shopId]"
          filterable
          remote
          clearable
          :remote-method="$event => getBrandListBy($event, item.shopId)"
          @focus="() => selectFocus(item.shopId)"
          @change="v => selectChange(v, item.shopId)"
        >
          <template v-if="brandOptions[item.shopId]">
            <el-option v-for="(brandOp, opIndex) in brandOptions[item.shopId]" :key="brandOp.vid" :label="brandOp.vvalue" :value="brandOp">
            </el-option>
          </template>
        </el-select>
         <el-link style="margin-left: 8px" @click="handleRefreshBrand(item)">刷新品牌</el-link>
         <el-link v-if="valueMap && valueMap[item.shopId] && valueMap[item.shopId].vvalue && !batchBrand"  style="margin-left: 8px" @click="handleSetToShop(item,valueMap[item.shopId].vvalue)">应用到其他店铺</el-link>
        <span v-if="getFail[item.shopId]" class="error-text">{{
          getFail[item.shopId] === true ? '店铺订购应用已过期，请重新订购以获取店铺品牌' : getFail[item.shopId]
        }}</span>
      </el-form-item>
    </el-form>
    <el-dialog-select-shop
        :visible.sync="shopDialogVisible"
        :shopData="shopList"
        :selected="selectShopIds"
        placeholder="店铺名称"
        @confirm="confirmSelectShop"
    ></el-dialog-select-shop>

  </div>
</template>

<script>
import { getBrandList, refreshBrand, getShopsBrandFill, ApplyToOtherShop } from '@/servers/prod/center/kuaishou.js';
import { getApplyBrandConfig } from '@/servers/prod/center/pdd.js';
import { mapGetters } from 'vuex';

const PLATFORMID = 'KWaiShop';

export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    source: {
      type: String, // 来源于详情还是批量删除页面，批量删除页面不需要默认根据店铺列表获取列表接口 batchDelete
      default() {
        return '';
      },
    },
    shopList: {
      type: Array,
      default() {
        return [];
      },
    },
    baseItemId: [String, Number],
    categoryId: {
      required: true,
    },
    batchBrand: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      inputBrandText: '',
      shopBrandList: [],
      valueMap: {},
      brandOptions: {},
      loading: {},
      getFail: {},
      shopDialogVisible: false,
      selectShopIds: '',
      applyShopName: '', // 发货时效应用的店铺名称
      _isUpdatingFromValue: false, // 防止循环更新的标志位
    };
  },
  computed: {
    ...mapGetters(['shops_getById']),
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this._isUpdatingFromValue = true;
        if (v && v.length) {
          this.valueMap = {};
          v.forEach(item => {
            this.$set(this.valueMap, item.shopId, this.buildCompleteItem(item, item.shopId));
          });
        } else {
          this.valueMap = {};
        }
        this.$nextTick(() => {
          this._isUpdatingFromValue = false;
        });
      },
    },
    valueMap: {
      deep: true,
      handler(v) {
        if (this._isUpdatingFromValue) return;
        const values = Object.values(v).map(item => this.buildCompleteItem(item, item.shopId));
        this.$emit('change', JSON.parse(JSON.stringify(values)));
      },
    },
    shopList: {
      immediate: true,
      async handler(v) {
        if (!v) return;
        this.updateBrands(v);
        // 针对批量删除100条以上数据默认根据店铺列表获取接口导致卡顿，所以批量删除默认不获取
        if (v.length > 0 && this.source != 'batchDelete') {
          await this.getBrandList();
        }
        this.$nextTick(() => {
          this.method_validate();
        });
      },
    },
  },
  methods: {
    // 统一构建品牌项数据结构，保证字段完整
    buildCompleteItem(raw, shopId) {
      const channel = this.shopList.find(shop => shop.id == shopId)?.channel || '';
      return {
        vid: raw && raw.vid ? raw.vid : '',
        vvalue: raw && raw.vvalue ? raw.vvalue : '',
        categoryId: raw && raw.categoryId ? raw.categoryId : this.categoryId,
        shopId: shopId,
        valueUnit: raw && raw.valueUnit ? raw.valueUnit : '',
        refPid: raw && raw.refPid ? raw.refPid : '',
        channel,
      };
    },
    itemRules(item) {
      const validShop = (rule, value, callback) => {
        if (!item.isRequired) {
          return callback();
        }
        const itemValue = this.valueMap[item.shopId] || {};
        if (!itemValue.vid) {
          return callback(new Error('该类目下品牌必填，品牌为空不支持商品发布'));
        }
        return callback();
      };
      return [{ required: item.isRequired, validator: validShop }];
    },
    async updateBrands(data) {
      this.shopBrandList = data.map(item => {
        const findItem = (this.value || []).find(v => v.shopId == item.id) || {};
        const completeItem = this.buildCompleteItem(findItem, item.id);
        this.$set(this.valueMap, item.id, completeItem);

        const shop = this.shops_getById(item.id) || {};
        return {
          shopId: item.id,
          userId: item.userId,
          shopName: shop.shortTitle || shop.title,
          shopIcon: shop.icon,
          channelIcon: shop.channelIcon,
          channelName: shop.channelName,
        };
      });
    },
    selectFocus(shopId) {
      if (!this.brandOptions[shopId] || !this.valueMap[shopId]?.vid) {
        this.getBrandListBy('', shopId);
      }
    },
    async getBrandListBy(query, shopId) {
      this.$set(this.loading, shopId, true);
      this.getFail = {};
      try {
        const data = await this.getBrandList({ query, shopId });
        const curShopItem = (data || []).find(item => item.shopId == shopId);
        if (!curShopItem) return;
        const options = curShopItem.brandList.map(item => ({ vid: item.vid, vvalue: item.name, shopId }));
        this.$set(this.brandOptions, shopId, options);
      } catch (error) {
        this.$set(this.getFail, shopId, (error && error.message) ? error.message : '品牌获取失败');
        console.log(error, '-----error');
      } finally {
        this.$set(this.loading, shopId, false);
      }
    },
    async getBrandList(params = {}) {
      const data = await getBrandList({ categoryLeafId: this.categoryId, baseItemId: this.baseItemId, ...params });
      this.shopBrandList.forEach(item => {
        const target = data.find(s => s.shopId == item.shopId);
        this.$set(item, 'isRequired', target ? target.isRequired : (item.isRequired || false));
      });
      return data;
    },
    selectChange(v, shopId) {
      const completeItem = this.buildCompleteItem(v || {}, shopId);
      this.$set(this.valueMap, shopId, completeItem);
    },
    method_validate() {
      return new Promise(resolve => {
        this.$refs.formRef.validate(valid => {
          resolve(valid);
        });
      });
    },
    async batchFillBrand() {
      const shopIds = this.shopList.map(shop => shop.id);
      const list = await getShopsBrandFill({ brandName: this.inputBrandText, categoryId: this.categoryId, shopIds });
      list.forEach(item => {
        const { shopId, scmKuaishouBrand } = item;
        const newItem = this.buildCompleteItem({ vid: scmKuaishouBrand.vid, vvalue: scmKuaishouBrand.name, categoryId: this.categoryId }, shopId);
        this.$set(this.valueMap, shopId, newItem);
      });
    },

    // 合并一键应用品牌配置的逻辑（支持是否跳过已有值）
    async applyBrandConfInternal({ skipExisting }) {
      const categoryId = this.categoryId;
      const categoryBrandRelations = await getApplyBrandConfig({ categoryId, baseItemId: this.baseItemId, shopType: PLATFORMID });
      const additionsMap = {};

      const existingFilledShopIds = skipExisting
        ? Object.keys(this.valueMap).filter(id => this.valueMap[id] && this.valueMap[id].vvalue)
        : [];

      // 先应用类目外设置数据
      this.shopList.forEach(shop => {
        const shopId = shop.id;
        const relations = (categoryBrandRelations.find(item => shopId == item.shopId) || {}).relations || [];
        const valueItem = relations.find(item => item.categoryId == categoryId);
        if (valueItem && (!skipExisting || !existingFilledShopIds.includes(String(shopId)))) {
          additionsMap[shopId] = this.buildCompleteItem({ ...valueItem, categoryId }, shopId);
        }
      });

      // 新增逻辑：检查是否有未匹配的 shopId（从其他店铺应用）
      const unmatchedShopIds = this.shopList
        .map(shop => shop.id)
        .filter(shopId => {
          const hasRelation = categoryBrandRelations.some(
            item => item.shopId == shopId && item.relations.find(r => r.categoryId == categoryId)
          );
          const skip = skipExisting && existingFilledShopIds.includes(String(shopId));
          return !hasRelation && !skip;
        });

      if (unmatchedShopIds.length > 0) {
        const res = await this.getApplyToOtherShop({
          shopType: PLATFORMID,
          shopIds: unmatchedShopIds.join(','),
          categoryId,
        });
        res && Object.keys(res).forEach(shopIdStr => {
          if (skipExisting && existingFilledShopIds.includes(String(shopIdStr))) return;
          const shopData = res[shopIdStr];
          if (shopData) {
            additionsMap[Number(shopIdStr)] = this.buildCompleteItem({ ...shopData, categoryId }, Number(shopIdStr));
          }
        });
      }

      const merged = Object.assign({}, this.valueMap, additionsMap);
      this._isUpdatingFromValue = true;
      this.$set(this, 'valueMap', merged);
      this.$emit('change', JSON.parse(JSON.stringify(Object.values(merged))));
      this.$nextTick(() => {
        this._isUpdatingFromValue = false;
      });
    },

    async useBrandConfInit() {
      await this.applyBrandConfInternal({ skipExisting: false });
    },
    async useBrandConf() {
      await this.applyBrandConfInternal({ skipExisting: true });
    },

    handleSetToShop(promiseConf, applyShopName) {
      this.shopDialogVisible = true;
      this.applyShopName = applyShopName;
    },
    async handleRefreshBrand(item) {
      const res = await refreshBrand({
        userId: item.userId,
        categoryId: this.categoryId,
      });
      if (res) {
        this.$message.success('更新品牌成功！');
      }
    },
    confirmSelectShop(shops) {
      this.shopDialogVisible = false;
      this.$confirm(
        `选中店铺将匹配品牌【${this.applyShopName}】，匹配后将覆盖原品牌值，未匹配到将跳过，是否确认`,
        '提示',
        {
          confirmButtonText: '确定',
          type: 'warning',
        }
      )
        .then(async () => {
          const shopIds = shops.map(item => item.id);
          const params = {
            shopType: PLATFORMID,
            shopIds: shopIds.join(','),
            categoryId: this.categoryId,
            brandName: this.applyShopName || ''
          };
          const res = await this.getApplyToOtherShop(params);
          for (const key in res) {
            const shopInfo = res[key];
            this.$set(this.valueMap, Number(key), this.buildCompleteItem({ ...shopInfo, categoryId: this.categoryId }, Number(key)));
          }
          this.$message.success('更新品牌成功！');
        })
        .catch(() => {});
    },
    async getApplyToOtherShop(payload) {
      const res = await ApplyToOtherShop({ ...payload });
      return res;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.brandIdBlock {
  ::v-deep .el-form-item {
    margin-bottom: 10px;
    .el-form-item__error {
      position: unset;
    }
  }

  ::v-deep .el-image {
    display: inline-block;
    vertical-align: middle;
  }
}

.error-text {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 10px;
}
</style>